import NullTableRegion from "../table/NullTableRegion";
import TableRegionChangeEvent from "../table/TableRegionChangeEvent";
import TableRegion from "../table/TableRegion";

export default class LockTableHoverController {
    constructor() {
        this.hoverRegion = NullTableRegion;
        this.listeners = [];
    }

    addHoverChangeListener(listener) {
        this.listeners.push(listener);
    }

    fireHoverChangeEvent(oldHoverRegion) {
        var hoverChangeEvent = new TableRegionChangeEvent(oldHoverRegion, this.hoverRegion);
        for (var i = 0; i < this.listeners.length; i++)
            this.listeners[i].call(this.listeners[i], hoverChangeEvent);
    }

    hover(startCell, endCell) {
        var oldHoverRegion = this.hoverRegion;
        this.hoverRegion = TableRegion.prototype.createFromCells(startCell, endCell);
        if (!this.hoverRegion.equals(oldHoverRegion))
            this.fireHoverChangeEvent(oldHoverRegion);
    }

    unhover() {
        var oldHoverRegion = this.hoverRegion;
        this.hoverRegion = NullTableRegion;
        this.fireHoverChangeEvent(oldHoverRegion);
    }

    isHovered(cell) {
        return this.hoverRegion != NullTableRegion && this.hoverRegion.contains(cell.getRow().getRowIdx(), cell.getColIdx());
    }

    getHoverRegion() {
        return this.hoverRegion;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/LockTableHoverController.js